import React, { useState, useEffect } from 'react';

const PageTitle = ({ title, breadcrumbs }) => (
    <div 
        className="bg-gray-100 py-16 md:py-24 text-center text-gray-800 relative overflow-hidden" 
        style={{ 
            backgroundImage: "url('/images/banner2.png')", 
            backgroundSize: 'cover', 
            backgroundPosition: 'center',
        }}
    >
        <div className="relative z-10 container mx-auto px-4 pb-10">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight animate-fadeInUp text-yellow-500">{title}</h1>
            {breadcrumbs && <p className="text-sm text-white mt-3 animate-fadeInUp animation-delay-300">{breadcrumbs}</p>}
        </div>
        <div className="absolute -bottom-2 left-0 w-full  h-auto opacity-100 overflow-hidden">
            <svg className="animate-wave-na" viewBox="0 0 1440 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 50C150 20 288 80 480 50C672 20 720 -20 960 50C1200 120 1300 20 1440 50V100H0V50Z" fill="rgb(255, 255, 255)"/>
            </svg>
        </div>
    </div>
);

export default PageTitle;